export interface WritingStyleChip {
  icon: string;
  label: string;
}

export interface PresentedWritingStyle {
  chips: WritingStyleChip[];
  analyzedAt?: string;
  empty: boolean;
}

export interface WritingStyleLabels {
  tone: string;
  sentenceLength: string;
  formality: string;
}

function scalarLabel(value: unknown): string | undefined {
  if (typeof value === 'string' && value.trim() !== '') return value;
  if (typeof value === 'number') return String(value);
  return undefined;
}

const DEFAULT_LABELS: WritingStyleLabels = {
  tone: 'Tone',
  sentenceLength: 'Sentence length',
  formality: 'Formality',
};

export function presentWritingStyle(ws: unknown, labels: WritingStyleLabels = DEFAULT_LABELS): PresentedWritingStyle {
  if (!ws || typeof ws !== 'object' || Array.isArray(ws)) {
    return { chips: [], empty: true };
  }

  const source = ws as Record<string, unknown>;
  const chips: WritingStyleChip[] = [];

  const tone = scalarLabel(source.tone);
  if (tone !== undefined) chips.push({ icon: 'mood', label: `${labels.tone}: ${tone}` });

  const sentenceLength = scalarLabel(source.sentence_length);
  if (sentenceLength !== undefined) chips.push({ icon: 'subject', label: `${labels.sentenceLength}: ${sentenceLength}` });

  const formality = scalarLabel(source.formality);
  if (formality !== undefined) chips.push({ icon: 'handshake', label: `${labels.formality}: ${formality}` });

  const analyzedAt = scalarLabel(source.updated_at);

  return {
    chips,
    ...(analyzedAt !== undefined ? { analyzedAt } : {}),
    empty: chips.length === 0,
  };
}
